<div
  class="mainContainer d-flex align-items-center mandala"
  style="height: 400px"
>
  <h2 class="headingBL d-flex flex-row align-items-center title">
    Virsa in<span class="ms-2">School</span>
  </h2>
  <div class="d-flex justify-content-between align-items-center Wrap w-100">
    <div class="d-flex flex-column align-items-center gap-3 detailsItem">
      <div class="details vtext">
        Virsa offers on-site learning with dedicated instructors, perfect for
        upskilling in various performing arts genres. Embrace cultural
        enrichment and enhance your artistic talents with Virsa, wherever you
        are.
      </div>
      <div class="btnGlobal--primary" routerLink="/form/contactUs">Contact Us</div>
    </div>
    <c-carousel class="carouselWrap">
      <c-carousel-indicators></c-carousel-indicators>
      <c-carousel-inner class="w-100 h-100 carouselInner">
        <c-carousel-item *ngFor="let slide of slides" class="w-100 h-100">
          <img
            [src]="slide.imageUrl"
            alt="{{ slide.caption }}"
            class="d-block imgC"
            loading="lazy"
          />
        </c-carousel-item>
      </c-carousel-inner>
      <c-carousel-control
        [routerLink]
        caption="Previous"
        direction="prev"
      ></c-carousel-control>
      <c-carousel-control
        [routerLink]
        caption="Next"
        direction="next"
      ></c-carousel-control>
    </c-carousel>
  </div>
</div>
